import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1afad24e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "transaction-data" }
const _hoisted_2 = {
  key: 0,
  class: "monospace signature",
  "data-testid": "signature"
}
const _hoisted_3 = {
  key: 1,
  class: "data"
}
const _hoisted_4 = {
  class: "monospace",
  "data-testid": "first-bytes"
}
const _hoisted_5 = { class: "method" }
const _hoisted_6 = { class: "data-params scrollable" }
const _hoisted_7 = {
  class: "data-index",
  "data-testid": "indexParam"
}
const _hoisted_8 = { class: "data-value byte-wrap" }
const _hoisted_9 = {
  key: 2,
  class: "no-data"
}

import { computed, ref, onMounted } from 'vue'

import Sanitize from '@/popup/components/shared/Sanitize.vue'
import { highlightSignature } from '@/popup/utils/highlightSignature'
import { useABIDecoder } from '@/popup/compositions/useABIDecoder'
import { getFunctionSignature } from '@/shared/getFunctionSignature'
import { logError } from '@/shared/logger'
import { useWeb3Eth } from '@/popup/compositions/useWeb3Eth'

type Props = {
  data?: string
  selector?: string
  functionSignature?: string
  isAdvancedView?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TransactionData',
  props: {
    data: {},
    selector: {},
    functionSignature: {},
    isAdvancedView: { type: Boolean }
  },
  setup(__props: any) {

const props = __props
const { decodeSignatureParams } = useABIDecoder()
const signature = ref(props.functionSignature)

const signatureParams = computed(() => {
  if (!signature.value || !props.data) {
    return []
  }

  return decodeSignatureParams(signature.value, props.data)
})

const firstBytes = computed(() => {
  return props.data?.slice(0, 10)
})

const params = computed(() => {
  return props.data?.slice(10).match(/.{1,64}/g)
})

const { getWeb3Eth } = useWeb3Eth()

onMounted(async () => {
  try {
    // if missing a function signature, get it from 4 bytes dictionary
    signature.value = await getFunctionSignature(getWeb3Eth(), props.data || '')
    // since we can get 4byte signature after a while we need to call
  } catch (error) {
    logError(
      `Error while getting function signature in TransactionData:`,
      error
    )
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (signature.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(Sanitize, {
            html: _unref(highlightSignature)(signature.value, signatureParams.value)
          }, null, 8 /* PROPS */, ["html"])
        ]))
      : _createCommentVNode("v-if", true),
    ((_ctx.isAdvancedView || !signature.value) && _ctx.data && _ctx.data !== '0x')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('transaction.generic.method')) + " " + _toDisplayString(firstBytes.value), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(params.value, (param, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `${param} - ${index}`,
                class: "monospace"
              }, [
                _createElementVNode("div", _hoisted_7, "[" + _toDisplayString(index) + "]", 1 /* TEXT */),
                _createElementVNode("div", _hoisted_8, _toDisplayString(param), 1 /* TEXT */)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (!_ctx.data || _ctx.data === '0x')
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t('transaction.no_data')), 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})